// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"fd9600cc","513":"c506cb72","582":"45a6fefd","787":"bdf7aeda"}[chunkId] + ".chunk.js";
};